import type {
  Campaign,
  CampaignListResult,
  CreateCampaignBody,
} from '@/types/notification.types';

import { apiClient } from './api.service';

export const notificationsApi = {
  list: (page = 1, limit = 20): Promise<CampaignListResult> =>
    apiClient
      .get<CampaignListResult>('/admin/campaigns', { params: { page, limit } })
      .then((r) => r.data),

  send: (body: CreateCampaignBody): Promise<Campaign> =>
    apiClient.post<Campaign>('/admin/campaigns', body).then((r) => r.data),
};
